import { GridCellProps } from "@progress/kendo-react-grid";
import * as React from "react";
import { EnumerationCell } from "../../../Layout/Grid/Cell/Default/EnumCell";
import { GridRowClickProps } from "../../../Layout/Grid/GridRowClickProps";
import { validationItemUpdateModeAsString } from "../ValidationItemUpdateMode";

export function ContainerTypeUpdateModeCell(props: GridCellProps & GridRowClickProps) {
  return <EnumerationCell {...props} mapping={validationItemUpdateModeAsString} />;
}
